import {Component, OnInit} from '@angular/core';
import {ConditionsComponent, HtmlDocumentDialogData} from '../conditions/conditions.component';
import {UtDialogService} from 'src/app/ui';
import {ActivatedRoute} from '@angular/router';
import {NavigationService} from '../services/nav/navigation.service';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
})
export class DocumentComponent implements OnInit {
  private documentId!: number;

  constructor(
    private dialog: UtDialogService,
    private route: ActivatedRoute,
    private nav: NavigationService,
  ) {
    route.params.subscribe((params) => {
      if (typeof params['documentId'] !== 'undefined') {
        this.documentId = params['documentId'];
        this.showDocument();
      }
    });
  }

  ngOnInit(): void {}

  showDocument(): boolean {
    const ref = this.dialog.open<ConditionsComponent, HtmlDocumentDialogData, void>(
      ConditionsComponent,
      {data: {documentId: this.documentId}},
    );
    ref.afterClosed().subscribe({
      next: () => this.nav.home(),
      error: () => this.nav.home(),
    });
    return false;
  }
}
